import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function BrokerDashboard() {
  const [stats, setStats] = useState(null);
  const [company, setCompany] = useState(null);
  useEffect(() => {
    api.get("/broker/stats").then((r) => setStats(r.data));
    api.get("/broker/company").then((r) => setCompany(r.data));
  }, []);
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight mb-2">Tableau de bord courtier</h1>
      {company && <p className="text-muted-foreground mb-6">{company.name} · Statut : <span className="font-mono">{company.status}</span></p>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">Clients</div><div className="text-3xl font-bold font-mono">{stats?.clients ?? 0}</div></div>
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">Dossiers</div><div className="text-3xl font-bold font-mono">{stats?.cases ?? 0}</div></div>
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">Revenu</div><div className="text-3xl font-bold font-mono">0,00 €</div></div>
      </div>
    </div>
  );
}

export function BrokerClientsPage() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "" });
  const load = () => api.get("/broker/clients").then((r) => setClients(r.data));
  useEffect(() => { load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/broker/clients", form);
      setForm({ first_name: "", last_name: "", email: "", phone: "" });
      load();
      toast.success("Client ajouté");
    } catch { toast.error("Erreur"); }
  };
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight mb-6">Mes clients</h1>
      <form onSubmit={submit} className="card-elevated p-4 mb-6 grid grid-cols-1 md:grid-cols-5 gap-3">
        <Input placeholder="Prénom" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} required data-testid="bc-first" />
        <Input placeholder="Nom" value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} required data-testid="bc-last" />
        <Input placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="bc-email" />
        <Input placeholder="Téléphone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="bc-phone" />
        <Button type="submit" data-testid="bc-add-btn">Ajouter</Button>
      </form>
      <div className="card-elevated overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50"><tr><th className="text-left px-4 py-3">Nom</th><th className="text-left px-4 py-3">Email</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Mandat</th></tr></thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id} className="border-t border-border">
                <td className="px-4 py-3 font-medium">{c.first_name} {c.last_name}</td>
                <td className="px-4 py-3 font-mono text-xs">{c.email}</td>
                <td className="px-4 py-3">{c.phone || "—"}</td>
                <td className="px-4 py-3">{c.mandate_signed ? "✓ Signé" : "En attente"}</td>
              </tr>
            ))}
            {clients.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-muted-foreground">Aucun client.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function BrokerCasesPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight mb-6">Dossiers</h1>
      <div className="card-elevated p-10 text-center text-muted-foreground">
        <p>Fonctionnalité en développement.</p>
        <p className="text-sm mt-2">Vous pourrez ici gérer les dossiers de résiliation de vos clients en masse.</p>
      </div>
    </div>
  );
}

export function BrokerStatsPage() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/broker/stats").then((r) => setStats(r.data)); }, []);
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight mb-6">Statistiques</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">Clients actifs</div><div className="text-3xl font-mono">{stats?.clients ?? 0}</div></div>
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">Dossiers en cours</div><div className="text-3xl font-mono">{stats?.cases ?? 0}</div></div>
        <div className="card-elevated p-6"><div className="text-xs uppercase text-muted-foreground mb-2">CA cumulé</div><div className="text-3xl font-mono">0,00 €</div></div>
      </div>
    </div>
  );
}

export function BrokerPaymentsPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight mb-6">Portefeuille & Paiements</h1>
      <div className="card-elevated p-6">
        <div className="text-xs uppercase text-muted-foreground mb-2">Solde du portefeuille</div>
        <div className="text-4xl font-bold font-mono mb-6">0,00 €</div>
        <p className="text-sm text-muted-foreground">Le portefeuille B2B (rechargement PayPal, tarif dégressif, traitement en masse) sera activé après la finalisation du contrat postal Live. Contactez le support pour un tarif dédié cabinet.</p>
      </div>
    </div>
  );
}
